<template>
  <layout-main-inner
    title="库存统计"
    class="stat-inventory">
    <div slot="action">
      <el-date-picker
        v-model="query.month"
        style="width: 140px"
        type="month"
        placeholder="选择月"
        format="yyyy 年 MM 月"
        :clearable="false"
        :editable="false"
        @change="fetch">
      </el-date-picker>
      <el-button
        style="margin-left: 10px"
        type="primary"
        @click="fetch">查询</el-button>
    </div>
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">本期数据</template>
      <el-row>
        <el-col :span="24">
          <summary-list
            :span="6"
            :list="summaryList" />
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="16">
          <v-title title="本期各商品库存数量（前20名）" />
          <stock-chart
            :xAxis="stock.xAxis"
            :series1="stock.series1"
            :series2="stock.series2" />
        </el-col>
        <el-col :span="8">
          <v-title title="本期各商品库存数量（20名以后）" />
          <stock-table :list="stock.list" />
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="16">
          <v-title title="本期各商品出入库数量（前20名）" />
          <in-out-stock-chart
            :xAxis="inoutStock.xAxis"
            :series1="inoutStock.series1"
            :series2="inoutStock.series2" />
        </el-col>
        <el-col :span="8">
          <v-title title="本期各商品出入库数量（20名以后）" />
          <in-out-stock-table :list="inoutStock.list" />
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="12">
          <v-title title="本期各商品库存占比" />
          <stock-precent-chart
            :legendData="pie1.legendData"
            :seriesData="pie1.seriesData"
            :selected="pie1.selected" />
        </el-col>
        <el-col :span="12">
          <v-title title="本期各商品入库占比" />
          <stock-precent-chart
            :legendData="pie2.legendData"
            :seriesData="pie2.seriesData"
            :selected="pie2.selected" />
        </el-col>
        <el-col :span="12">
          <v-title title="本期各商品出库占比" />
          <stock-precent-chart
            :legendData="pie3.legendData"
            :seriesData="pie3.seriesData"
            :selected="pie3.selected" />
        </el-col>
      </el-row>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import SummaryList from './busi/summary.vue'
import StockChart from './inventory/stock-chart.vue'
import StockTable from './inventory/stock-table.vue'
import InOutStockChart from './inventory/in-out-stock-chart.vue'
import InOutStockTable from './inventory/in-out-stock-table.vue'
import StockPrecentChart from './inventory/stock-precent-chart.vue'
import VTitle from './v-title.vue'

const SLICE_NUM = 20
const SELECTED = 10
export default {
  name: 'StatInventory',
  components: { SummaryList, StockChart, StockTable, InOutStockChart, InOutStockTable, StockPrecentChart, VTitle },
  data() {
    return {
      loading: false,
      query: {
        month: +moment()
      },
      summaryList: [
        {
          label: '期初库存数',
          value: 0
        },
        {
          label: '期末库存数',
          value: 0
        },
        {
          label: '本期入库数',
          value: 0
        },
        {
          label: '本期出库数',
          value: 0
        }
      ],
      stock: {
        xAxis: [],
        series1: [],
        series2: [],
        list: []
      },
      inoutStock: {
        xAxis: [],
        series1: [],
        series2: [],
        list: []
      },
      pie1: {
        legendData: [],
        seriesData: [],
        selected: {}
      },
      pie2: {
        legendData: [],
        seriesData: [],
        selected: {}
      },
      pie3: {
        legendData: [],
        seriesData: [],
        selected: {}
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true
      const { month } = this.query
      this.$store.dispatch('stat/suminventoryinout', {
        payload: {
          beginDate: moment(month).startOf('month').format('YYYYMMDD'),
          endDate: moment(month).endOf('month').format('YYYYMMDD')
        },
        success: (res) => {
          this.loading = false
          console.log(res)
          this.$set(this, 'summaryList', [
            {
              label: '期初库存数',
              value: res.data.periodBeginStockQuantity
            },
            {
              label: '期末库存数',
              value: res.data.periodEndStockQuantity
            },
            {
              label: '本期入库数',
              value: res.data.periodInStockQuantity
            },
            {
              label: '本期出库数',
              value: res.data.periodOutStockQuantity
            }
          ])
          this.formatData(res.data.periodStockDetails)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    formatData(detail) {
      const stockAllList = []
      detail.forEach(i => {
        const { productName, periodBeginStockQuantity,
          periodEndStockQuantity, periodInStockQuantity,
          periodOutStockQuantity, periodStockQuantityPercent,
          periodInStockQuantityPercent, periodOutStockQuantityPercent } = i
        stockAllList.push({
          productName, periodBeginStockQuantity,
          periodEndStockQuantity, periodInStockQuantity,
          periodOutStockQuantity, periodStockQuantityPercent,
          periodInStockQuantityPercent, periodOutStockQuantityPercent
        })
      })
      const stockList = _.sortBy(stockAllList, (i) => -i.periodEndStockQuantity)
      const chartList = stockList.slice(0, SLICE_NUM)
      this.stock.xAxis = chartList.map(i => i.productName)
      this.stock.series1 = chartList.map(i => i.periodBeginStockQuantity)
      this.stock.series2 = chartList.map(i => i.periodEndStockQuantity)
      this.stock.list = stockList.slice(SLICE_NUM)

      const inoutList = _.sortBy(stockAllList, (i) => -i.periodInStockQuantity)
      const inoutChartList = inoutList.slice(0, SLICE_NUM)
      this.inoutStock.xAxis = inoutChartList.map(i => i.productName)
      this.inoutStock.series1 = inoutChartList.map(i => i.periodInStockQuantity)
      this.inoutStock.series2 = inoutChartList.map(i => i.periodOutStockQuantity)
      this.inoutStock.list = inoutList.slice(SLICE_NUM)

      const pie1Data = _.sortBy(stockAllList, (i) => -i.periodStockQuantityPercent)
      const pie1Result = this.formatPie(pie1Data, 'periodStockQuantityPercent')
      this.pie1.legendData = pie1Result.legendData
      this.pie1.seriesData = pie1Result.seriesData
      this.pie1.selected = pie1Result.selected

      const pie2Data = _.sortBy(stockAllList, (i) => -i.periodInStockQuantityPercent)
      const pie2Result = this.formatPie(pie2Data, 'periodInStockQuantityPercent')
      this.pie2.legendData = pie2Result.legendData
      this.pie2.seriesData = pie2Result.seriesData
      this.pie2.selected = pie2Result.selected

      const pie3Data = _.sortBy(stockAllList, (i) => -i.periodOutStockQuantityPercent)
      const pie3Result = this.formatPie(pie3Data, 'periodOutStockQuantityPercent')
      this.pie3.legendData = pie3Result.legendData
      this.pie3.seriesData = pie3Result.seriesData
      this.pie3.selected = pie3Result.selected
    },
    formatPie(list, key) {
      const legendData = []
      const seriesData = []
      const selected = {}
      list.forEach((i, idx) => {
        legendData.push(i.productName)
        seriesData.push({
          name: i.productName,
          value: i[key]
        })
        selected[i.productName] = idx < SELECTED
      })
      return {
        legendData,
        seriesData,
        selected
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
    .grid-content {
        height 300px;
    }
</style>
